import { gql } from '@apollo/client';

export const CampaignSchedulerFlowQuery = gql`
  query CampaignSchedulerFlow($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      schedulerFlow {
        id
        companyId
        config
        name
        nlpAgentId
        smsGenerator
      }
    }
  }
`;
